export default {"src":"https://cdn.sa-tech.de/homeone/main/_next/static/media/dimdi.34d8e9ad.svg","height":74,"width":89,"blurWidth":0,"blurHeight":0};